import React from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import PendingChangeWrapper from '@sharedCR/common/PendingChangeWrapper';
import PropTypes from 'prop-types';

import { PendingChangeKind } from 'constants/pendingChanges';
import useModifiedFieldPendingChangeAuthors from 'hooks/useModifiedFieldPendingChangeAuthors';

import { selectChartLegend } from 'store/loanApplications/selectors';

const ChartInfo = ({ name = '', value = '', changeKind = null, fieldName = null }) => {
  const { modifiedFieldDetails } = useSelector(selectChartLegend);
  const getModifiedFieldAuthors = useModifiedFieldPendingChangeAuthors();

  return (
    <div className="flex gap-4">
      <Typography className="whitespace-nowrap" color="text.secondary" variant="regular16">
        {name}:
      </Typography>
      <PendingChangeWrapper
        isSmall
        authors={getModifiedFieldAuthors(modifiedFieldDetails, fieldName)}
        changeKind={changeKind}
        fieldLabel={name}
        textSelector="span"
      >
        <Typography color="text.primary" variant="bold16">
          {value}
        </Typography>
      </PendingChangeWrapper>
    </div>
  );
};

ChartInfo.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  changeKind: PropTypes.oneOf(Object.values(PendingChangeKind)),
  // The chart legend's modified field this value shows; its author dots read that field's changes.
  fieldName: PropTypes.string,
};

export default ChartInfo;
